import React, { useState, useContext } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Button,
  Tooltip,
  Slide,
  Divider,
} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import Logo from "../logowhite.png";
import LogoDunomo from "../logodunomo.png";
import { RegionContext } from "../RegionContext";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function Appbar() {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const { data, setData } = useContext(RegionContext);

  const open = Boolean(anchorEl);

  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const handleRegion = (regionCode) => () => {
  //   setData((prevState) => ({
  //     ...prevState,
  //     region: regionCode,
  //   }));

  //   handleClose();

  //   navigate("/");
  // };

  return (
    <AppBar className="navbar" position="relative">
      <Toolbar>
        <Container maxWidth="xl">
          <Box id="padding">
            <Box id="inner-box">
              <IconButton
                sx={{
                  display: { xs: "initial", md: "none" },
                }}
                onClick={() => {
                  setData((prevState) => ({
                    ...prevState,
                    drawer_open: !prevState.drawer_open,
                  }));
                }}
              >
                {data.drawer_open ? <MenuOpenIcon /> : <MenuIcon />}
              </IconButton>
              {data.region === "au" ? (
                <img className="logo" src={LogoDunomo} width={150} />
              ) : (
                <img className="logo" src={Logo} width={150} />
              )}

              <Tooltip title="Select region">
                {/* <IconButton
                  onClick={handleClickListItem}
                  className="globe-button"
                >
                  <Typography>ae</Typography>
                  <LanguageIcon />
                  {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton> */}

                <Button
                  startIcon={<LanguageIcon />}
                  endIcon={
                    open ? <ExpandLessIcon /> : <ExpandMoreIcon fontSize="2x" />
                  }
                  className="globe-button"
                  onClick={handleClickListItem}
                >
                  {data.region}
                </Button>
              </Tooltip>

              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                id="navbar-dropdown"
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    borderRadius: "8px",
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <a href="https://api.paymate.sg/GlobalPartnerAPI">
                  {/* <a href="https://devsgp.paymateb2b.com/GlobalPartnerAPI"> */}
                  <MenuItem
                    selected={
                      window.location.host === "devsgp.paymateb2b.com" ||
                      window.location.host === "api.paymate.sg"
                    }
                  >
                    Singapore
                  </MenuItem>
                </a>

                <a href="https://api.dunomo.au/GlobalPartnerAPI">
                  {/* <a href="https://devaus.paymateb2b.com/GlobalPartnerAPI"> */}
                  <MenuItem
                    selected={
                      window.location.host === "devaus.paymateb2b.com" ||
                      window.location.host === "api.dunomo.au"
                    }
                  >
                    Australia
                  </MenuItem>
                </a>

                <a href="https://api.paymate.my/GlobalPartnerAPI">
                  {/* <a href="https://devmys.paymateb2b.com/GlobalPartnerAPI"> */}
                  <MenuItem
                    selected={
                      window.location.host === "devmys.paymateb2b.com" ||
                      window.location.host === "api.paymate.my"
                    }
                  >
                    Malaysia
                  </MenuItem>
                </a>

                <a href="https://api.paymate.ae/GlobalPartnerAPI">
                  {/* <a href="https://devuae.paymateb2b.com/GlobalPartnerAPI"> */}
                  <MenuItem
                    selected={
                      window.location.host === "devuae.paymateb2b.com" ||
                      window.location.host === "api.paymate.ae"
                    }
                  >
                    UAE
                  </MenuItem>
                </a>

                <a href="https://api.paymate.om/GlobalPartnerAPI">
                  {/* <a href="https://devomn.paymateb2b.com/GlobalPartnerAPI"> */}
                  <MenuItem
                    selected={
                      window.location.host === "devomn.paymateb2b.com" ||
                      window.location.host === "api.paymate.om"
                    }
                  >
                    Oman
                  </MenuItem>
                </a>

                <a href="https://api.dunomo.co.za/GlobalPartnerAPI">
                  {/* <a href="https://devzaf.paymateb2b.com/GlobalPartnerAPI"> */}
                  <MenuItem
                    selected={
                      window.location.host === "devzaf.paymateb2b.com" ||
                      window.location.host === "api.dunomo.co.za"
                    }
                  >
                    South Africa
                  </MenuItem>
                </a>
              </Menu>
            </Box>
          </Box>
        </Container>
      </Toolbar>
    </AppBar>
  );
}

export default Appbar;
